import Dialog from "../../../1. Core/Controls/Dialog/Dialog";
import TextField from "../../../1. Core/Controls/TextField/TextField";
import NP from "../../../1. Core/NP";
import {getTournaments, ITournament} from "../../Util";
import {EventTournament, IBattle, OnlineTextWidgetMetadata, SportType, Widget} from "../../types";
import {ServerAPI} from "../../../1. Core/ServerAPI";
import {WidgetType} from "../WEnum";
import Select from "../../../1. Core/Controls/Select/Select";
import ColorPicker from "../../../1. Core/Controls/ColorPicker/ColorPicker";


export default class OnlineTextWidgetEditDialog extends Dialog {
	private _name: TextField;
	private _leftTopLogoUrlInput: TextField;
	private _logoRightBottomLogoUrlInput: TextField;
	private _backgoundUrlInput: TextField;

	private _eventCombo: Select;
	private _tournamentCombo: Select;
	private _battleCombo: Select;

	private _Widget: Widget<OnlineTextWidgetMetadata>;
	private _tEvents: EventTournament[];
	private _fontCombo: Select;
	private _fontColor: ColorPicker;
	private _Battle: IBattle;

	_initFields(settings: object)
	{
		this._Battle = null;
		this._Widget = null;
		super._initFields(settings);
		this._Mode = 'FullHeight';
		this._Caption = NP.RM.getString('Event');
		this._CloseOnFrameMouseDown = true;
		this._ShowHeader = true;
		this._ShowCloseButton = true;
		this._OkRK = 'Save'
		this._AutoDestroy = true;
		this._Width = 360;
	}

	_render()
	{
		super._render();

		this._name = new TextField({
			FloatingLabel: NP.RM.getString('Name'),
			ParentNode: this._contentNode
		});

		this._backgoundUrlInput = new TextField({
			FloatingLabel: NP.RM.getString('Background'),
			ParentNode: this._contentNode,
			EvChanging: () => this.onSettingsChanged()
		});

		this._leftTopLogoUrlInput = new TextField({
			FloatingLabel: NP.RM.getString('LogoLeftTop'),
			ParentNode: this._contentNode,
			EvChanging: () => this.onSettingsChanged()
		});

		this._logoRightBottomLogoUrlInput = new TextField({
			FloatingLabel: NP.RM.getString('LogoRightBottom'),
			ParentNode: this._contentNode,
			EvChanging: () => this.onSettingsChanged()
		});

		this._tournamentCombo = new Select({
			ParentNode: this._contentNode,
			FloatingLabel: NP.RM.getString('Tournament'),
			EvItemSelected: () => this.updateEvents()
		});

		this._eventCombo = new Select({
			ParentNode: this._contentNode,
			FloatingLabel: NP.RM.getString('Event'),
			EvItemSelected: () => this.updateBattleList()
		});

		this._battleCombo = new Select({
			ParentNode: this._contentNode,
			FloatingLabel: NP.RM.getString('Battle'),
			EvItemSelected: () => this.onSettingsChanged()
		});

		this._fontCombo = new Select({
			ParentNode: this._contentNode,
			Value: 'Muller',
			Items: [
				{Content: 'Muller', Value: 'Muller'},
				{Content: 'Roboto', Value: 'Roboto'},
				{Content: 'Corbert', Value: 'Corbert'},
				{Content: 'Bourgeois', Value: 'Bourgeois'},
				{Content: 'Swis', Value: 'Swis721 Blk BT'},
				{Content: 'PF Din Text Comp Pro', Value: 'PF Din Text Comp Pro'}
			],
			FloatingLabel: NP.RM.getString('FontFamily'),
			EvItemSelected: () => this.onSettingsChanged()
		});

		this._fontColor = new ColorPicker({
			ParentNode: this._contentNode,
			FloatingLabel: NP.RM.getString('FontColor'),
			EvColorChanged: () => this.onSettingsChanged()
		})


		if (this._Widget)
		{
			this._name.setValue(this._Widget.Name)
			this._backgoundUrlInput.setValue(this._Widget.Metadata.Background)
			this._leftTopLogoUrlInput.setValue(this._Widget.Metadata.LogoLeftTop)
			this._logoRightBottomLogoUrlInput.setValue(this._Widget.Metadata.LogoRightBottom)
		}
		else
		{
			this._Widget = {
				Metadata: {WId: WidgetType.OnlineText}
			} as Widget<OnlineTextWidgetMetadata>

			if (this._Battle)
			{
				this._Widget.Metadata.FightId = this._Battle.Id;
				this._name.setValue(this._Battle.RedName + ' vs ' + this._Battle.BlueName)
			}
		}
		this.refresh()
	}

	onSettingsChanged()
	{
	}

	updateObjSettings()
	{
		this._Widget.Name = this._name.getValue();
		this._Widget.Metadata.FightId = this._battleCombo.getValue()
		this._Widget.Metadata.Background = this._backgoundUrlInput.getValue()
		this._Widget.Metadata.LogoLeftTop = this._leftTopLogoUrlInput.getValue()
		this._Widget.Metadata.LogoRightBottom = this._logoRightBottomLogoUrlInput.getValue()
		this._Widget.Metadata.FontFamily = this._fontCombo.getValue()
		this._Widget.Metadata.FontColor = this._fontColor.getValue()
	}

	async updateBattleList()
	{
		let res = await ServerAPI.post<{ List: IBattle[], AllCount: number }>("/battle/items", {
			TournamentId: this._tournamentCombo.getValue(),
			EventId: this._eventCombo.getValue()
		});

		this._battleCombo.setItems(res.List.map(b => ({
			Content: `${b.RedName} VS ${b.BlueName}`,
			Value: b.Id
		})))
	}

	async refresh()
	{

		let tList = await getTournaments(SportType.MMA) as ITournament[]


		let items = tList.map(t => ({Value: t.Id, FontImage: NP.FontImages.integration, Content: t.Name, Data: t}));
		this._tournamentCombo.setItems(items);


		if (this._Widget && this._Widget.Metadata.FightId)
		{
			let battle = await ServerAPI.get<IBattle>(`/battle/${this._Widget.Metadata.FightId}`)
			this._tournamentCombo.setValue(battle.TournamentId, false)
			await this.updateEvents(battle.TournamentId);
			this._eventCombo.setValue(battle.EventId, false);

			await this.updateBattleList();
			this._battleCombo.setValue(this._Widget.Metadata.FightId, false);
		}
		else
		{
			if (tList[0])
			{
				this._tournamentCombo.setValue(tList[0].Id)
				this.updateEvents();
			}
		}
	}

	async updateEvents(tId: number = null)
	{
		let response = await ServerAPI.callUiApi("/t-events", {
			Count: 500,
			Offset: 0,
			TournamentId: tId || this._tournamentCombo.getValue()
		}, 'POST') as { List: EventTournament[], AllCount: number };
		this._tEvents = response.List;
		this._eventCombo.setItems(response.List.map(ev => ({Content: ev.Name, Value: ev.Id})));
	}


	async _onOkButtonClick()
	{
		if (!this._name.getValue().trim() || !this._battleCombo.getValue())
			return;

		this.updateObjSettings();

		if (this._Widget.Id)
			await ServerAPI.callUiApi(`/widget/${this._Widget.Id}`, this._Widget, 'POST');
		else
			await ServerAPI.callUiApi("/widget", this._Widget, 'PUT')


		this.EvOkButtonClick.fire(this);
		this.hide();
	}
}